import tippy from 'tippy.js';
import { onDomReady } from './events';

window.initializeTippy = (selector) => {
  document.querySelectorAll(selector).forEach((element) => {
    tippy(element, {
      delay: 500,
      touch: ['hold', 200],
      content: (el) => el.dataset.tooltip,
      allowHTML: element.hasAttribute('data-tooltip-allow-html'),
    });
    element.addEventListener('touchstart', (event) => event.stopPropagation());
    element.addEventListener('touchend', (event) => event.stopPropagation());
    element.addEventListener('touchclick', (event) => event.stopPropagation());
  });
};

onDomReady(() => {
  window.initializeTippy('[data-tooltip]');
})
